import { render, staticRenderFns } from "./ExcelOficiosAutorizacion.vue?vue&type=template&id=0f342fd4&"
import script from "./ExcelOficiosAutorizacion.vue?vue&type=script&lang=js&"
export * from "./ExcelOficiosAutorizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports